import React, { FC, useContext, useEffect, useState } from 'react';

import { CircularProgress, FormControl, FormLabel, Chip } from '@material-ui/core';
import { ValueType } from 'react-select/lib/types';

import { GlobalContext } from '../../../../../../../store';
import { IRoundGame } from '../../../../../../../store/admin/eventRounds/store';

import { PlayerMetaDataSectionStyled } from './PlayerMetaDataSection.Styles';
import AutoComplete from '../../../../../../../components/AutoComplete';
import { IOption } from '../../../../../../../components/Select/Select';
import { getAutoCompleteOptionsArray } from '../../../../../../../contrib/Utils/getAutoCompleteOptionsArray';
import { useRouteInfoState } from '../../../../../../../components/RouteInfo/Context/RouteInfo.context';

interface IProps {
  game: IRoundGame | undefined;
}

const Tees: FC<IProps> = props => {
  const { game } = props;

  const {
    actions: {
      adminEventRounds: { updateGames }
    },
    adminEventRounds: { current: round },
    playerEditorModal: { enrollment },
    adminEventEnrollments
  } = useContext(GlobalContext);

  const { clubId, eventId, roundId } = useRouteInfoState();

  const [options, setOptions] = useState<IOption[]>([]);

  const [sectionState, setSectionState] = useState<'idle' | 'loading' | 'saved'>('idle');

  useEffect(() => {
    if (round && round.course.tees && round.course.tees.length > 0 && !!enrollment) {
      const gameEnrollment = adminEventEnrollments[Number(eventId)].find(
        eventEnrollment => eventEnrollment.id === enrollment.id
      );

      const gameEnrollmentGender = gameEnrollment ? gameEnrollment.user.profile.gender : undefined;

      const filteredByGenderTees = round.course.tees.filter(tee =>
        gameEnrollmentGender ? tee.gender === gameEnrollmentGender : true
      );

      setOptions(getAutoCompleteOptionsArray(filteredByGenderTees));
    }
  }, [round, enrollment, adminEventEnrollments, eventId]);

  const [value, setValue] = useState<IOption>();

  const onChange: (value: ValueType<IOption>) => Promise<void> = async selectedTee => {
    if (game && clubId && eventId && roundId) {
      const tee = Number((selectedTee as IOption).value);

      setSectionState('loading');

      const response = await updateGames(clubId, eventId, roundId, [{ ...game, tee }]);

      if (response.errors) {
        // manage errors somehow
        setSectionState('idle');
      } else {
        setValue(options.find(c => c.value === (selectedTee as IOption).value));

        setSectionState('saved');

        setTimeout(() => setSectionState('idle'), 3 * 1000);
      }
    }
  };

  useEffect(() => {
    if (game) {
      setValue(options.find(c => game && String(c.value) === String(game.tee)));
    }
  }, [game, options]);

  if (!round || !enrollment) {
    return <></>;
  }

  const stateIndicators = {
    idle: <></>,
    loading: <CircularProgress className="loader" size={15} />,
    saved: <Chip size="small" label="Saved" color="primary" variant="outlined" />
  };

  return (
    <PlayerMetaDataSectionStyled>
      <FormControl classes={{ root: 'formcontrol-container' }} component="fieldset">
        <FormLabel component="legend">
          <p>TEES:</p>

          {stateIndicators[sectionState]}
        </FormLabel>

        <AutoComplete value={value} onChange={onChange} options={options} isDisabled={!game} />
      </FormControl>
    </PlayerMetaDataSectionStyled>
  );
};
export default Tees;
